export const OFFLINE_LOCATOR_KEY = 'meridian.event-offline.locators';
export interface OfflineEventLocator { userId: string; eventId: string }
export function readOfflineScopes(): OfflineEventLocator[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(OFFLINE_LOCATOR_KEY) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter(item => item && typeof item.eventId === 'string' && typeof item.userId === 'string') : [];
  } catch { return []; }
}
export function readOfflineActors(eventId: string): string[] { return readOfflineScopes().filter(item => item.eventId === eventId).map(item => item.userId); }
export function rememberOfflineScope(userId: string, eventId: string): void {
  localStorage.setItem(OFFLINE_LOCATOR_KEY, JSON.stringify([...readOfflineScopes().filter(item => item.userId !== userId || item.eventId !== eventId), { userId, eventId }]));
}
export function forgetOfflineScope(userId: string, eventId: string): void {
  localStorage.setItem(OFFLINE_LOCATOR_KEY, JSON.stringify(readOfflineScopes().filter(item => item.userId !== userId || item.eventId !== eventId)));
}
